import { Button, TextField, IconButton } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Box from "elements/Box";
import { ProjectConfig } from "Global";
import { useSnackbar, withSnackbar } from "notistack";
import CameraAltIcon from "@mui/icons-material/CameraAlt";

export default withSnackbar(function HomeIconsEditor(props: any) {
  const { enqueueSnackbar } = useSnackbar();
  const { icon_id } = useParams();
  const navigate = useNavigate();

  const defaultValues: any = {
    icon_id: icon_id || "",
    module_key: "",
    bg_color: "#BF7A1C",
    image: "",
  };

  const [loading, setLoading] = useState(false);
  const [formValues, setFormValues] = useState(defaultValues);
  const [files, setFiles] = useState<any>(null);

  /*=========================================================
  LOAD ICON DETAILS
  =========================================================*/
  useEffect(() => {
    if (icon_id) {
      axios
        .get(ProjectConfig.api_url, {
          params: {
            request: "home_icons_details",
            icon_id: icon_id,
          },
        })
        .then((response) => {
          console.log("Icon details:", response.data);
          const data = response.data;
          setFormValues({
            icon_id: data.icon_id,
            module_key: data.module_key,
            bg_color: data.bg_color || "#BF7A1C",
            image: data.image ? `${ProjectConfig.api_url.replace('/api/', '/')}/files/home_icons/${data.image}` : "",
          });
          setLoading(true);
        })
        .catch((err) => {
          console.log(err);
          enqueueSnackbar("Error al cargar el icono", { variant: "error" });
        });
    }
  }, [icon_id]);

  /*=========================================================
  HANDLERS
  =========================================================*/
  const handleInputChange = (e: { target: { name: any; value: any } }) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };

  /*=========================================================
  SUBMIT
  =========================================================*/
  const handleSubmit = () => {
    console.log("Submitting:", formValues);

    const formData = new FormData();
    formData.append("request", "home_icons_update");
    formData.append("icon_id", icon_id || "");
    formData.append("formValues", JSON.stringify(formValues));

    if (files) {
      formData.append("files", files);
    }

    axios
      .post(ProjectConfig.api_url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        console.log(response);
        if (response.data.success) {
          enqueueSnackbar("Icono actualizado correctamente", { variant: "success" });
          navigate("/admin/home-icons");
        } else {
          enqueueSnackbar("Error al guardar", { variant: "error" });
        }
      })
      .catch((err) => {
        console.log(err);
        enqueueSnackbar("Error al guardar", { variant: "error" });
      });
  };

  return (
    <div id="HomeIconsEditor">
      <div className="userForm_right">
        <Box
          id="home_icons_editor"
          className="box_editor"
          title="Diseño - Iconos del Home"
          subtitle="Editar"
        >
          <div className="input_group">
            <div className="input_row">
              <TextField
                id="module_key"
                name="module_key"
                label="Módulo"
                type="text"
                disabled
                fullWidth
                value={formValues.module_key}
                sx={{ width: "500px" }}
              />
            </div>

            <div className="input_row">
              <TextField
                id="bg_color"
                name="bg_color"
                label="Color de fondo"
                type="color"
                value={formValues.bg_color || "#BF7A1C"}
                onChange={handleInputChange}
                sx={{ width: "200px" }}
              />
            </div>

            {/* UPLOAD IMAGE - Matches Oraciones pattern */}
            <div className="input_row" style={{ flexDirection: 'column', alignItems: 'flex-start', gap: '8px' }}>
              <div style={{ marginBottom: '8px' }}>
                <strong>Imagen del icono</strong>
                <div style={{ fontSize: '12px', color: '#666', marginTop: '4px' }}>
                  Tamaño recomendado: 128x128px | Formato: PNG con fondo transparente
                </div>
              </div>
              <div className="drawerImagesContainer">
                <div
                  className="drawerImagesContainerDiv"
                  style={{
                    backgroundColor: formValues.bg_color || "#f5f5f5",
                  }}
                  onDrop={(e) => {
                    e.preventDefault();
                    const files = e.dataTransfer.files;
                    if (files && files[0]) {
                      setFiles(files[0]);
                      const fileURL = URL.createObjectURL(files[0]);
                      setFormValues({ ...formValues, image: fileURL });
                    }
                    e.currentTarget.classList.remove("dropzone_active");
                  }}
                  onDragOver={(e) => {
                    e.preventDefault();
                    e.currentTarget.classList.add("dropzone_active");
                  }}
                  onDragLeave={(e) => {
                    e.preventDefault();
                    e.currentTarget.classList.remove("dropzone_active");
                  }}
                >
                  {formValues.image && <img src={formValues.image} />}

                  <label
                    id="dropFileDiv"
                    className={formValues.image ? "showOnlyOnHover" : ""}
                  >
                    <IconButton
                      aria-label="upload"
                      size="small"
                      className="addFile_button"
                      component="span"
                    >
                      <CameraAltIcon />
                      <input
                        type="file"
                        hidden
                        accept="image/*"
                        onChange={(e) => {
                          const files = e.target.files;
                          if (files && files[0]) {
                            setFiles(files[0]);
                            const fileURL = URL.createObjectURL(files[0]);
                            setFormValues({ ...formValues, image: fileURL });
                          }
                        }}
                      />
                    </IconButton>
                  </label>
                </div>
              </div>
            </div>

            <div className="input_row" style={{ marginTop: '20px' }}>
              <Button variant="contained" onClick={handleSubmit}>
                Guardar cambios
              </Button>
              <Button
                variant="outlined"
                onClick={() => navigate("/admin/home-icons")}
                style={{ marginLeft: '10px' }}
              >
                Cancelar
              </Button>
            </div>
          </div>
        </Box>
      </div>
    </div>
  );
});
